import { motion } from "framer-motion";
import { Heart, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="py-12 px-4 bg-foreground text-background">
      <div className="container max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <div className="flex items-center justify-center gap-2 mb-4">
            <MapPin className="w-5 h-5 text-primary" />
            <span className="text-xl font-serif">Portugal 2026</span>
          </div>
          <p className="text-background/60 text-sm">
            Made with{" "}
            <motion.span
              animate={{ scale: [1, 1.2, 1] }}
              transition={{ duration: 1, repeat: Infinity }}
              className="inline-block"
            >
              <Heart className="w-4 h-4 inline text-primary fill-primary" />
            </motion.span>{" "}
            for our adventure
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;